module.exports = __webpack_public_path__ + "static/img/tea-buzhou.76c53727.png";